
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";

@Component
export default class ebiEditbar extends Vue {
	@PropSync('visible', { type: Boolean }) private show!: boolean;
	@Prop() private title!: string;
}
